module.exports = __webpack_public_path__ + "static/po-cs-work-image-d1de205322c85bfaf068b1196480d396.jpg";